import { render, staticRenderFns } from "./AccountPayHistory.vue?vue&type=template&id=381813ea&"
import script from "./AccountPayHistory.vue?vue&type=script&lang=ts&"
export * from "./AccountPayHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports